import React, { useState } from "react"
import types from "prop-types"
import CreateGroupModal from "shared/modals/CreateGroupModal"
import EmptyGroups from "./EmptyGroups"
import GroupWithMembers from "./GroupWithMembers"

const GroupList = ({ groups: initialGroups }) => {
  const [groups, setGroups] = useState(initialGroups)
  const removeGroup = (groupId) => setGroups(groups.filter(({ id }) => id !== groupId))

  if (groups.length === 0) return <EmptyGroups />

  return (
    <>
      <CreateGroupModal />
      {
        groups.map((group) => (
          <GroupWithMembers key={group.id} group={group} removeGroup={removeGroup} />
        ))
      }
    </>
  )
}

GroupList.propTypes = {
  groups: types.arrayOf(types.object).isRequired,
}

export default GroupList
